import { createContext } from "react";
const AppointmentsModalProviderContext = createContext({ toggleModal: () => {
} });
export {
  AppointmentsModalProviderContext
};
